import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import NotificationBell from '../notifications/NotificationBell';
import { FaTasks, FaSignOutAlt, FaUser, FaUserShield } from 'react-icons/fa';
import './Navbar.css';

const Navbar = () => {
  const { isAuthenticated, logout, user, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-content">
          <Link to="/" className="navbar-brand">
            <FaTasks className="brand-icon" />
            <span>Task Manager</span>
          </Link>
          
          {isAuthenticated && (
            <div className="navbar-menu">
              <NotificationBell />
              
              {isAdmin() && (
                <Link to="/admin" className="admin-link">
                  <FaUserShield /> Admin
                </Link>
              )}
              
              <div className="user-info">
                <FaUser className="user-icon" />
                <span>{user?.name}</span>
                {user?.role === 'admin' && (
                  <span className="admin-badge">Admin</span>
                )}
              </div>
              <button onClick={handleLogout} className="btn btn-logout">
                <FaSignOutAlt />
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
